@if (typeView !== 'translationsViewNoEditable' && typeView !== 'translationsViewEditable') {
  <div class="customize-fields__inner-container">
    <field-type-number
      [field]="customizeFieldNum.decimalsInfo"
      [decimals]="0"
      [preSelectItem]="customizeFieldNum.field.decimals"
      (itemSelected)="itemSelected($event, 'decimals')">
    </field-type-number>
    <field-type-number
      [field]="customizeFieldNum.defaultValueInfo"
      [preSelectItem]="customizeFieldNum.field.defaultValue"
      [decimals]="customizeFieldNum.field.decimals"
      (itemSelected)="itemSelected($event, 'defaultValue')">
    </field-type-number>
    <customize-fields-switch-form
      [field]="customizeFieldNum.field"
      [small]="true"
      [concept]="concept"
      [isPrivate]="isPrivate"
      [hiddenInLandings]="hiddenInLandings"
      [typeView]="typeView"
      [previewMode]="previewMode">
    </customize-fields-switch-form>
  </div>
}

